export const OVERRIDE_TYPE = {
  NONE: 'none', // No override - slot is within working hours and doesn't overlap
  CALENDAR: 'calendar', // Overlaps with a busy event
  WORKING_HOURS: 'working_hours', // Outside working hours
  CALENDAR_WORKING_HOURS: 'calendar_working_hours', // Skips both calendar + working_hours filters (was :all in BE)
} as const;

export type OverrideType = (typeof OVERRIDE_TYPE)[keyof typeof OVERRIDE_TYPE];

// check if the value is a valid override type
export const isValidOverrideType = (value: string): value is OverrideType => {
  return (Object.values(OVERRIDE_TYPE) as string[]).includes(value);
};

export const getOverrideType = (
  overlapsWithBusyEvent: boolean,
  outsideWorkingHours: boolean
): OverrideType => {
  if (overlapsWithBusyEvent && outsideWorkingHours) {
    return OVERRIDE_TYPE.CALENDAR_WORKING_HOURS;
  }
  if (overlapsWithBusyEvent) {
    return OVERRIDE_TYPE.CALENDAR;
  }
  if (outsideWorkingHours) {
    return OVERRIDE_TYPE.WORKING_HOURS;
  }
  return OVERRIDE_TYPE.NONE;
};

// check if the slot has any override
export const hasOverride = (overrideType?: string): boolean => {
  return overrideType !== OVERRIDE_TYPE.NONE && overrideType !== undefined;
};
